import { SDG } from '@Types';

export const formatSDG = (sdg: SDG) => {
  return `${sdg.name} - ${sdg.label}`;
};
